import { IAppState } from 'src/store/types';

export const getFilteredLayouts = (state: IAppState) => state.layouts.filteredData;
